<template>
  <div>
    <b-row class="mb-3">
      <b-col lg="3" md="6" xs="12">
        <b-form-datepicker @input="inputChanged" v-model="initialDate" class="mb-2"></b-form-datepicker>
      </b-col>
      <b-col lg="3" md="6" xs="12">
        <b-form-datepicker @input="inputChanged" v-model="lastDate" :min="minLastDate" class="mb-2"></b-form-datepicker>
      </b-col>
      <b-col lg="3" md="6" xs="12">
        <b-button class="mb-2" variant="default" v-b-modal.modal-sucursals block>Sucursales: {{ sucursals.length }} Seleccionadas</b-button>
      </b-col>
      <b-col lg="3" md="6" xs="12">
        <b-button class="mb-2" variant="default" v-b-modal.modal-waiters block>Meseros: {{ waiters.length > 0 ? waiters.length + ' Seleccionados' : 'Todos' }}</b-button>
      </b-col>
      <b-col lg="12" md="6" xs="12">
        <b-button variant="success" @click="changeDate" block>Buscar</b-button>
      </b-col>
    </b-row>

    <!-- Sucursales Modal -->
    <b-modal ok-only id="modal-sucursals" @ok="inputChanged" title="Sucursales">
      <b-row>
        <b-col>
          <b-button-group>
            <b-button variant="success" @click="selectAllSucursals()">Seleccionar todo</b-button>
            <b-button variant="danger" @click="sucursals = []">Quitar selección</b-button>
          </b-button-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <b-form-checkbox-group stacked v-model="sucursals" :options="sucOptions">
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

    <!-- Waiters Modal -->
    <b-modal ok-only id="modal-waiters" @ok="inputChanged" title="Meseros">
      <b-row>
        <b-col>
          <b-button-group>
            <b-button variant="success" @click="selectAllWaiters()">Seleccionar todo</b-button>
            <b-button variant="danger" @click="waiters = []">Todos los meseros</b-button>
          </b-button-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <b-form-checkbox-group stacked v-model="waiters" :options="waiterOptions">
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment';

export default {
  name: "WaiterReportSearchBar",
  watch: {
    initialDate(i) {
      this.minLastDate = moment(i).format()
      if (moment(this.initialDate).isAfter(moment(this.lastDate))) {
        this.lastDate = null
      }
    }
  },
  props: {
    emitOnStart: {
      type: Boolean,
      default: true
    },
    emitOnChange: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      initialDate: null,
      lastDate: null,
      minLastDate: null,
      sucOptions: [],
      sucursals: [],
      waiterOptions: [],
      waiters: []
    };
  },
  mounted() {
    console.log("waiterReportSearchBar mounted")
    moment().locale("es-mx")
    this.initialDate = moment().subtract(7, "days").format()
    this.lastDate = moment().add(1, "days").format()
    this.minLastDate = moment(this.initialDate).add(1, 'days').format()
    this.getSucursals()
    this.getWaiters()
  },
  methods: {
    selectAllSucursals() {
      let that = this
      this.sucursals = []
      this.sucOptions.forEach((element) => {
        that.sucursals.push(element.value)
      })
    },
    selectAllWaiters() {
      let that = this
      this.waiters = []
      this.waiterOptions.forEach((element) => {
        that.waiters.push(element.value)
      })
    },
    getSucursals() {
      let that = this;
      axios
        .get("/sucursals")
        .then(function (response) {
          let l = response.data.sort((a, b) => { return a.nombre.localeCompare(b.nombre) })
          let fill = that.sucursals.length === 0
          l.forEach((element) => {
            that.sucOptions.push({ text: element.nombre, value: element.id });
            if (fill) {
              that.sucursals.push(element.id)
            }
          });
          if (that.emitOnStart && that.waiterOptions.length > 0) {
            that.changeDate()
          }
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    getWaiters() {
      let that = this;
      axios
        .get("/waiters")
        .then(function (response) {
          let l = response.data.sort((a, b) => { return a.name.localeCompare(b.name) })
          l.forEach((element) => {
            that.waiterOptions.push({ text: element.name, value: element.id });
          });
          // Don't select all waiters by default - leave empty for "all"
          if (that.emitOnStart && that.sucOptions.length > 0) {
            that.changeDate()
          }
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    changeDate() {
      console.log("changeDate")
      this.$emit("search", {
        sucursales: this.sucursals,
        initDate: this.initialDate,
        endDate: this.lastDate,
        waiters: this.waiters
      })
    },
    inputChanged() {
      this.$emit("changed", {
        sucursales: this.sucursals,
        init: this.initialDate,
        end: this.lastDate,
        waiters: this.waiters
      })
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  }
}
</script>
